import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';
const themeStyles = new ThemeStyles();
themeStyles.addBaseStyles('Container')(() => css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
}));
themeStyles.addBaseStyles('LabelWrapper')(() => css({
    gap: 'xs',
    display: 'flex',
    alignItems: 'center',
}));
themeStyles.addBaseStyles('CheckboxWrapper')(() => css({
    marginTop: '-4px',
}));
themeStyles.addBaseStyles('StyledTooltip')(() => css({
    display: 'inline-flex',
    verticalAlign: 'top',
    marginLeft: '8px',
}));
export default themeStyles;
